<template>
<div>
  <!-- 查询区域 -->
  <div class="main_container">
    <div class="fuji" @click="show3 = !show3">
      <p style="margin: 0;margin-left: -22px;" class="goodslist1">
        <span style="margin-left:31px;margin-top:5px">搜索/查询</span>
        <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
      </p>
      <div style="position: absolute;right:-19px;top:-10px" class="sanjiao"/>
    </div>
    <el-collapse-transition>
      <div style="padding:0 12px" v-show="show3">
        <el-form
          :inline="true"
          :model="formInline"
          class="demo-form-inline findform"
          style="display:flex;margin-top:10px;height:55px">
          <el-form-item style="width:100%;display:flex" label="活动标题：">
            <el-input v-model="name" placeholder="请输入活动栏目名称" maxlength="20"/>
          </el-form-item>
          <el-form-item style="display:flex;width:100%" label="所属城市：">
            <el-cascader placeholder="请选择城市" :options="options" style="width:100%" v-model="chengshi"
              filterable clearable @expand-change="exchange" @change="handleChange"/>
          </el-form-item>
          <el-form-item style="display:flex;width:100%;" label="状　　态：" class="select">
            <el-select
              filterable
              v-model="stateId"
              placeholder="请选择"
              style="background:#fff;width:100%"
              ref="mySelect1">
              <el-option
                :label="item.Name"
                :value="item.Id"
                v-for="(item,index) in statearr"
                :key="index"/>
            </el-select>
          </el-form-item>
        </el-form>
        <el-form
          :inline="true"
          :model="formInline"
          class="demo-form-inline findform"
          style="display:flex;margin-top:10px;height:55px"
        >
          <el-form-item style="display:flex;width:34.1%;" label="活动时间：" class="select">
            <el-date-picker
            v-model="value6"
            @change="handleChangeTime"
              value-format="yyyy-MM-dd"
            type="daterange"
            style="width:100%"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"/>
          </el-form-item>
          <el-form-item style="display:flex;width:33.3%;" class="select"></el-form-item>
          <el-form-item style="display:flex;width:33.3%;margin-left:30px;" class="select">
            <el-button type="danger" @click="getActiveList()" style="float:right">查 询</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-collapse-transition>
  </div>
  <!-- 列表区域 -->
  <div class="banner">
    <div style=" position: relative;">
      <p class="goodslist1">
        <span style="margin-left:15px;">活动管理列表</span>
        <span class="goods_red"></span>
      </p>
      <p style="position: absolute;right:30px;top:-12px">
        <el-button type="danger" style="margin-right:20px" @click="showadd()">+ 新 增</el-button>
      </p>
    </div>
    <div style="margin-right:40px">
      <template>
        <el-table :data="goodList" stripe border style="height:auto;">
          <el-table-column prop="Title" label="活动标题" align="center">
            <template scope="scope">
              <span
                :title="scope.row.Title"
                style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
              >{{scope.row.Title}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="City" label="所属城市" align="center">
            <template scope="scope">
              <span
                :title="scope.City"
                style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
              >{{scope.row.City}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="ActiveTime" align="center" label="活动时间">
            <template scope="scope">
              <span
                :title="scope.row.ActiveTime"
                style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
              >{{scope.row.ActiveTime}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="SignCount" label="报名人数" align="center">
            <template scope="scope">
              <span style="color:#6786b4;margin-left:8px;cursor: pointer;"
                @click="popNum(scope)"
              >{{scope.row.SignCount}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="StatusName" label="状态" align="center">
            <template scope="scope">
              <span
                :title="scope.row.StatusName"
                style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
              >{{scope.row.StatusName}}</span>
            </template>
          </el-table-column>
          <el-table-column prop label="操作" width="360px" fixed="right" align="center">
            <template scope="scope">
              <span v-if="scope.row.Status != 4" style="color:#6786b4;margin-left:8px;cursor: pointer;" @click="changstate(scope)">
                <i :class="scope.row.Status == 2?'el-icon-circle-close':'el-icon-circle-check'"></i>
                {{scope.row.Status==2?"关闭":"开启"}}
              </span>
              <span v-if="scope.row.Status == 1 " style="color:#6786b4;margin-left:8px;cursor: pointer;" @click="emitinfo(scope)">
                <i class="el-icon-edit-outline"></i>
                编辑
              </span>
              <span v-if="scope.row.Status != 1" style="color:#6786b4;margin-left:8px;cursor: pointer;" @click="seeinfo(scope)">
                <i class="el-icon-view"></i>
                  查看
              </span>
              <span v-clipboard:copy="message" v-clipboard:success="onCopy" v-clipboard:error="onCopy" style="color:#6786b4;margin-left:8px;cursor: pointer;" @click="copy(scope, 1)">
                <i class="el-icon-paperclip"></i>
                  复制PC
              </span>
              <span v-clipboard:copy="message" v-clipboard:success="onError" v-clipboard:error="onError" style="color:#6786b4;margin-left:8px;cursor: pointer;" @click="copy(scope, 2)">
                <i class="el-icon-paperclip"></i>
                  复制小程序
              </span>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </div>
    <div style="margin-right:40px">
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="10"
        :current-page="pageIndex"
        :total="total"
        style="float:right;margin-top:10px;"/>
    </div>
  </div>
  <!-- 报名人数弹框 -->
  <addPopNum v-if="dialogVisibledelete" ref="add" :rooid="rooid"/>
  <el-dialog title="外层 Dialog" :visible.sync="outerVisible">
  <el-dialog
    width="30%"
    title="内层 Dialog"
    :visible.sync="innerVisible"
    :modal-append-to-body="false">
  </el-dialog>
  <div slot="footer" class="dialog-footer">
    <el-button @click="outerVisible = false">取 消</el-button>
    <el-button type="primary" @click="innerVisible = true">打开内层 Dialog</el-button>
  </div>
</el-dialog>
</div>
</template>
<script>
import { getkind,SelectRegionOfflineActiveByCondtion,UpdateROAStatusByIdAndStatusId } from "../../api/api";
import addPopNum from './addPopNum'
export default {
  name: "ActivityManagement",
  data() {
    return {
       outerVisible: false,
        innerVisible: false,
      rooid: "", // rooid
      value6:'',
      pageIndex: 1, // 页码
      total: 0,
      message:"113",
      dialogVisibledelete: false,
      show3: false,
      formInline: {},
      name: "",
      chengshi: "",
      goodList: [],
      sTime:"",
      eTime:"",
      stateId: 0,
      statearr: [],
      provinceId: 0,
      cityId: 0,
      tbdprovince: [],
      tbdcity: [],
      optionsindex: 0,
      options: [
        {
          value: 0,
          label: "全部"
        }
      ]
    };
  },
  components: {
    addPopNum
  },
  methods: {
    //获取活动列表 
    getActiveList(){
      var obj = {
        operId:localStorage.Id,
        title:this.name,
        cityId:this.cityId,
        provinceId:this.provinceId,
        statusId:this.stateId,
        sTime:this.sTime,
        eTime:this.eTime,
        pageIndex:this.pageIndex, // 页码
        pageSize:10
      }
      SelectRegionOfflineActiveByCondtion(obj).then(data=>{
          if(data.ResultCode ==1){
            this.goodList = data.ResultObj;
            this.total =data.RowsCount;
          }else{
            this.goodList = [];
            this.total = 0;
          }
      })
    },
    // 点击报名人数
    popNum(scope) {
      if (scope.row.SignCount == 0) {
        // this.$swal({
        //   type:"warning",
        //   text:"无报名人数"
        // })
        return;
      }
      this.rooid = scope.row.Id
      this.dialogVisibledelete = true;
      this.$nextTick(() => {
        this.$refs.add.init()
      })
    },
    // 重置
    fnReset() {
      this.name = "";
      this.chengshi = "";
      this.provinceId = 0;
      this.cityId = 0;
      this.stateId = 0;
      this.value6 = "";
      this.sTime = 0;
      this.eTime = 0;
      // this.pageIndex = 1;
      // this.getActiveList();
    },
    // 查询活动列表分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getActiveList();
    },
    //时间选择器修改
    handleChangeTime(val){
       if(val == null){
         this.sTime  = "";
         this.eTime = "";
         return false
       }
      this.sTime = val[0];
      this.eTime = val[1];
    },
    //新增
    showadd() {
      this.$router.push({
          path:"/ActivityDetails",
      })
    },
    //编辑
    emitinfo(scope){
     this.$router.push({
       path:"/ActivityDetails",
       query:{
         type:1,
         Id:scope.row.Id
       }
     })
    },
    //查看
    seeinfo(scope){
      this.outerVisible =true;
      return
     this.$router.push({
       path:"/ActivityDetails",
       query:{
         type:2,
         Id:scope.row.Id
       }
     })
    },
    //开启/关闭
    changstate(scope){
      var text = ''
      if (scope.row.Status == 2) {
        text = '您确定关闭吗？'
      } else {
        text = '您确定开启吗？'
      }
      this.$swal({
        type:'warning',
        text: text,
        showCancelButton:true,
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        }).then(res => {
          if (res.value) {
            var obj = {
              roaId:scope.row.Id,
              opId:scope.row.Status == 2 ? 0 : 1
            }
            UpdateROAStatusByIdAndStatusId(obj).then(data=>{
              if(data.ResultCode == 1){
                this.$swal({
                  type:"success",
                  text:"操作成功"
                })
                  this.getActiveList()
              }
            })
          }
        })
    },
    // 复制PC
    onCopy: function (e) {
      this.$swal({
        type:"success",
        text:"复制链接成功"
      })
   },
   // 复制小程序
   onError: function (e) {
    this.$swal({
      type:"success",
      text:"复制链接成功"
    })
   },
    copy(scope, type){
      if (type == 1) {
        if (localStorage.BaseUrl == 'http://192.168.0.220:8009') {
          this.message = "http://www.taozhuanr.com:8010/activityDetail?id=" + scope.row.Id
        } else {
          this.message = "http://www.taozhuanr.com/activityDetail?id=" + scope.row.Id
        }
      }
      if (type == 2) {
        this.message = "/component/pages/taozhuanr_home/sales_promotion/sales_promotion?id="+scope.row.Id
      }
    },
    //活动管理-查询区域-状态
    getStatearr(){
      var obj = {
        tableName:"tROAStatus",
        keyWord:"",
      }
      getkind(obj).then(data=>{
        if(data.ResultCode == 1){
          this.statearr = data.ResultObj;
          this.statearr.unshift({
            Id:0,
            Name:"全部"
          })
        }
      })
    },
    // 展开子菜单时触发
    exchange(val) {
      this.provinceId = val[0];
      for (var i = 0; i < this.options.length; i++) {
        if (this.options[i].value == val[0]) {
          this.optionsindex = i;
          this.getcity();
        }
      }
    },
    // 请选择省市
    handleChange(val) {
      this.provinceId = val[0];
      this.cityId = val[1];
    },
    // 查找省
    getprovince() {
      let that = this;
      var loginParams = {
        tableName: "tbdprovince",
        keyWord: "",
        parentId: ""
      };
      getkind(loginParams).then(data => {
        var obj = {};
        data.ResultObj.map(item => {
          obj = item;
          obj["value"] = item["Id"];
          obj["label"] = item["Name"];
          obj["children"] = [];
          this.options.push(obj);
        });
        data = data.ResultObj;
        var obj = {
          Id: 0,
          Name: "全部"
        };
        data.unshift(obj);
        that.tbdprovince = data;
      });
    },
    // 查找市
    getcity() {
      let that = this;
      var loginParams = {
        tableName: "tbdcity",
        keyWord: "",
        parentId: this.provinceId
      };
      getkind(loginParams).then(data => {
        that.tbdcity = [];
        var obj1 = {
          value: 0,
          label: "全部"
        };
        var obj = {};
        data.ResultObj.map(item => {
          obj = item;
          obj["value"] = item["Id"];
          obj["label"] = item["Name"];
          this.tbdcity.push(obj);
        });
        this.tbdcity.unshift(obj1);
        that.options[that.optionsindex].children = that.tbdcity;
        this.$forceUpdate();
      });
    }
  },
  mounted() {
    this.getprovince();
    this.getStatearr();
    this.getActiveList();
  }
};
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// ActivityManagement.vue?4eae0565